import * as parts from './parts'

export interface CallsColors {
  ListView: parts.CallsListViewColors
}

export const callsColors: CallsColors = {
  ListView: parts.callsListViewColors,
}
